/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Ai_OzelliklerInputs */

const tr_faq_a_ai_ozellikler = /** @type {(inputs: Faq_A_Ai_OzelliklerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri mesajlarına yanıt önerisi ve ürün açıklaması gibi konularda yapay zekadan yararlanabilirsin. Mesajlar sayfasındaki ajan senin adına yanıt taslağı hazırlar; otomatik yanıtı açmadıysan gönderip göndermeme kararı sende kalır.`)
};

const en_faq_a_ai_ozellikler = /** @type {(inputs: Faq_A_Ai_OzelliklerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can use AI for things like reply suggestions for customer messages and product descriptions. The agent on the messages page prepares reply drafts on your behalf; unless you have turned on auto reply, you decide whether to send them.`)
};

const de_faq_a_ai_ozellikler = /** @type {(inputs: Faq_A_Ai_OzelliklerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst die KI zum Beispiel für Antwortvorschläge auf Kundennachrichten und für Produkttexte nutzen. Der Agent auf der Nachrichtenseite bereitet in deinem Namen Antwortentwürfe vor; solange du automatische Antworten nicht eingeschaltet hast, entscheidest du, ob sie gesendet werden.`)
};

const ru_faq_a_ai_ozellikler = /** @type {(inputs: Faq_A_Ai_OzelliklerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ можно использовать, например, для подсказок ответов на сообщения покупателей и для описаний товаров. Агент на странице сообщений готовит черновики ответов от вашего имени; если вы не включили автоответ, решение об отправке остаётся за вами.`)
};

/**
* | output |
* | --- |
* | "You can use AI for things like reply suggestions for customer messages and product descriptions. The agent on the messages page prepares reply drafts on your..." |
*
* @param {Faq_A_Ai_OzelliklerInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_ai_ozellikler = /** @type {((inputs?: Faq_A_Ai_OzelliklerInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Ai_OzelliklerInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_ai_ozellikler(inputs)
	if (locale === "de") return de_faq_a_ai_ozellikler(inputs)
	if (locale === "ru") return ru_faq_a_ai_ozellikler(inputs)
	return tr_faq_a_ai_ozellikler(inputs)
});